export default {
  reportParams(state, params) {
    return (state.reportParams = params);
  },
  activeName(state, value) {
    return (state.activeName = value);
  },
};
